import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { FiSend } from "react-icons/fi";
import { useGlobal } from "../../context/GlobalContext";
import { sendReport } from "../../services/api";
import "./Popup.css";

export default function EmailPopup({ open, onClose, onSubmit }) {
  const [email, setEmail] = useState("");
  const [cellphone, setCellphone] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading
  const inputRef = useRef(null);
  const { state, dispatch } = useGlobal();
  const navigate = useNavigate();

  // Basic validators (adjust as you like)
  const emailValid = /^\S+@\S+\.\S+$/.test(email);
  // Very simple BR-friendly cellphone check: 10–15 digits (with optional + and non-digits allowed)
  const digits = cellphone.replace(/\D/g, "");
  const cellphoneValid = digits.length >= 10 && digits.length <= 15;

  const formValid = emailValid && cellphoneValid;

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onKey);
    setTimeout(() => inputRef.current?.focus(), 0);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  const submit = async (e) => {
    e.preventDefault();
    if (!formValid || status === "loading") return;

    setStatus("loading");
    dispatch({ type: "UPDATE_STATE", payload: { isLoading: true } });

    const emailData = {
      user: state.user,
      cellphone,
      email,
      masterplan_id: state.masterplan_id,
    };

    try {
      // Send to your backend
      await sendReport(emailData);

      // Optional parent callback gets both values
      await onSubmit?.({ email, cellphone });

      // Keep a single, structured update in global state
      dispatch({
        type: "UPDATE_STATE",
        payload: { contact: { email, cellphone }, isLoading: false },
      });

      onClose?.();
      navigate("/final");
    } catch (err) {
      // you might want to set an error message in state here
      dispatch({ type: "UPDATE_STATE", payload: { isLoading: false } });
      console.error(err);
    } finally {
      setStatus("idle");
    }
  };

  if (!open) return null;

  return createPortal(
    <div className="modal-backdrop" onClick={onClose} role="presentation">
      <div
        className="popup-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="popup-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="popup-title" className="popup-title">
          Insira seu e-mail e telefone de contato e receba o seu Masterplan na caixa de entrada.
        </h3>

        <form className="popup-row" onSubmit={submit}>
          <input
            ref={inputRef}
            type="email"
            placeholder="nome@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="tel"
            placeholder="(11) 91234-5678"
            value={cellphone}
            onChange={(e) => setCellphone(e.target.value)}
            required
          />

          <button type="submit" className="send-button" disabled={!formValid || status === "loading"}>
            <FiSend className="send-icon" />
            {status === "loading" ? "Enviando..." : "Enviar"}
          </button>
        </form>

        {/* Tiny helper text (optional) */}
        {!emailValid && email.length > 0 && (
          <small className="helper-text">Forneça um e-mail válido.</small>
        )}
        {!cellphoneValid && cellphone.length > 0 && (
          <small className="helper-text">Informe um celular válido (10–15 dígitos).</small>
        )}
      </div>
    </div>,
    document.body
  );
}
